import React, { useState } from "react";
import { Col, Row, Container } from "react-bootstrap";
import { Select, Button } from "@veneer/core";
import './close-case.css';
import { Trans, useTranslation } from "react-i18next";
interface UpdateCaseProps {
  caseClsOpts: { Key: string, Value: string }[]; // Adjusted type
  cancelCaseHandler: () => void;
  submitCaseHandler: (val: any) => void;
}

const CloseCase: React.FC<UpdateCaseProps> = ({ cancelCaseHandler, submitCaseHandler, caseClsOpts }) => {
  const [updateText, setUpdateText] = useState<string>('');
const [isDisabled, setIsDisabled] = useState(true);
  const submitHandler = () => {
    submitCaseHandler(updateText)
  }
  
  const updateTextHandler = (selectedOption: any) => {
    setIsDisabled(false); 
    setUpdateText(selectedOption?.value)
  }
  const {t} = useTranslation();

  return (
    <div className="close-case-container">
      <h4>{t("HPI.EditCase.RequestClose.CloseCase",{defaultValue:'Request to close this case'})}</h4>
      <p className="caption-regular">{t("HPI.EditCase.RequestClose.CloseData",{defaultValue:'By submitting this request, an agent will close this case. Once closed, it cannot be reopened'})}</p>

      <Container className="container-custom">
        <Col md={6} className="container-row">
          <Row>
            <Col> 
              <Select
                options={caseClsOpts.map(opt => ({ label: opt.Value, value: opt.Key }))}
                label={t("HPI.EditCase.RequestClose.ReasonCloseCase",{defaultValue:'Provide a reason for closing your case'})}
                id="yes-accident"
                placement="bottom"
                separateLabel
                className="select textbox"
                helperTextVisibility="auto"
                name="close-case"
                clearIcon={false}
                onChange={(selectedOption: any) => {
                  updateTextHandler(selectedOption);
                }}
              />
            </Col>

          </Row>
          <Row>
            <Col>
              <div className="footer">
                <Button small onClick={cancelCaseHandler}>
                {t("HPI.Cancel",{defaultValue:'Cancel'})}
                </Button>

                <Button
                  small
                  disabled={isDisabled}
                  onClick={submitHandler}
                >
                  {t("HPI.EditCase.btnSubmit",{defaultValue:'Submit'})}
                </Button>
              </div>
            </Col>

          </Row>
        </Col>
      </Container>

    </div>
  );
};

export default CloseCase;
